const d = ["#741009", "#f8d2c2", "#5f2972"], c = ["#741009", "#e6a07c", "#f8d2c2", "#c29fd5", "#5f2972"], E = [
  "#741009",
  "#df8963",
  "#edb694",
  "#f8d2c2",
  "#d0b4dd",
  "#b389cd",
  "#5f2972"
];
export {
  d as DIVERGING_RED_PURPLE_3,
  c as DIVERGING_RED_PURPLE_5,
  E as DIVERGING_RED_PURPLE_7
};
//# sourceMappingURL=index.es5696.js.map
